import authHeader from '../../../common/AuthHeader';
import { API_URL } from '../../apis';

const getMentorListing = async () => {
  const result = await fetch(`${API_URL}business_block/business`, { headers: { token: `${authHeader().token}` } });
  const response = await result.json();
  return [response.data];
};

export default {
  getMentorListing,
};
